var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClientBadge',{attrs:{"client":_vm.customer,"label":_vm.label,"href":_vm.href,"name":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }